import React from 'react'
import MoveSequence from '../../components/kiosk/KioskContent/MoveSequence/MoveSequence'
import {useUserState} from '../../context/UserContext'

const Move = ({parentPage}) => {
  const {user} = useUserState()
  
  return (
    <MoveSequence
      type={'MOVE_SPACE_CHANGE'}
      user={user}
      parentPage={parentPage}
    />
  )
}

export default Move
